// extracted by mini-css-extract-plugin
module.exports = {"headerTitleColumn":"AdminUserManagement_headerTitleColumn_1x2Jm","tableName":"AdminUserManagement_tableName_3sJAG","spinAround":"AdminUserManagement_spinAround_1HF2O"};